import { v4 as uuid } from 'uuid'

export interface IReminder {
  id: string
  priceListEntryId: string
  text: string
  vendorCompanyId: string
  restaurantCompanyId: string
}

export class Reminder implements IReminder {
  public id: string

  constructor(
    public text: string,
    public vendorCompanyId: string,
    public restaurantCompanyId: string,
    public priceListEntryId: string
  ) {
    this.id = uuid()
  }
}
